import React from "react";

import ChatContainer from "./ChatContainer";

export const ChatPanel: React.FC = () => {
	return <ChatContainer mode="fullscreen" />;
};

export default ChatPanel;
